import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import logo from '/images/junfel-logo.svg'

const RootLayout = () => {
	return (
		<>
			{/* <header>
				<Navbar />
			</header> */}
			<div className="dashboard_main_wrapper">
				<div className="dashboard_secondary_wrapper">
					<Sidebar />
					<main>
						<Outlet />
					</main>
				</div>
			</div>
		</>
	);
};

export default RootLayout;
